import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { API } from '../../shared/api.constants';
import { map } from 'rxjs/operators';
@Injectable()
export class ItemService {
	private resourceVerify = API.host + 'InvoicePortal/VerifyXml';
	constructor(private http: HttpClient) { }
	public uploadFile(fileToUpload: File) {
		const _formData = new FormData();
		_formData.append(fileToUpload.name, fileToUpload);
		return this.http.post(this.resourceVerify, _formData)
	  }
}
